<template>
  <div class="container">
    <div class="left">
      <div class="top">在线设备各省占比
        <salecircle :data="pieCharData"></salecircle>
      </div>
      <div class="bottom">已激活设备Top5省份/自治区
        <saleline :data="lineCharData"></saleline>
      </div>
    </div>
    <div class="middle">
      <!-- <div class="info_menus">
        <div class="item">
          <span>设备总量</span>
          <div class="count">{{total}}</div>
        </div>
        <div class="item">
          <span>活跃设备量</span>
          <div class="count">{{onlineTotal}}</div>
        </div>
        <div class="item">
          <span>累计消息</span>
          <div class="count">{{messageCount}}</div>
        </div>
      </div> -->
      <el-row class="info_menus" :span="24">
        <el-col class="item" :span="8">
          <span>设备总量</span>
          <div class="border"></div>
          <div class="count">{{total}}</div>
        </el-col>
        <el-col class="item" :span="8">
          <span>活跃设备量</span>
           <div class="border"></div>
          <div class="count">{{onlineTotal}}</div>
        </el-col>
        <el-col class="item" :span="8">
          <span>累计消息</span>
           <div class="border"></div>
          <div class="count">{{messageCount}}</div>
        </el-col>
      </el-row>
      <china-map
        v-if="provinceChartData.length > 0 && cityChartData.length > 0"
        :cityChartData="cityChartData"
        :provinceChartData="provinceChartData"></china-map>
    </div>
    <div class="rightContent">
      <div class="right">
      <div class="title">
        设备消息
        <div class="title_menus">
          <span>产品型号</span>
          <span class="message">消息</span>
          <span>时间</span>
        </div>
      </div>
      <div class="messageContent" id="messageContent">
          <template v-for="item in 15">
          <div :key="item" class="device_statu">
            <span>haier{{item}}</span>
            <span>下线</span>
            <span>09:33:45</span>
          </div>
        </template>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import ChinaMap from '@/components/home/map.vue'
import saleline from '@/components/home/line.vue'
import salecircle from '@/components/home/circle.vue'
import { deviceCount } from '@/api/log'
import { homeMap } from '@/api/dataStatistics'

function startmarquee (lh, speed, delay, id) {
  var t
  var p = false
  var o = document.getElementById(id)
  if (o) o.innerHTML += o.innerHTML
  o.onmouseover = function () {
    p = true
  }
  o.onmouseout = function () {
    p = false
  }
  o.scrollTop = 0

  function start () {
    t = setInterval(scrolling, speed)
    if (!p) o.scrollTop += 1
  }

  function scrolling () {
    if (o.scrollTop % lh !== 0) {
      o.scrollTop += 1
      if (o.scrollTop >= o.scrollHeight / 2) o.scrollTop = 0
    } else {
      clearInterval(t)
      setTimeout(start, delay)
    }
  }
  setTimeout(start, delay)
}
export default {
  name: 'Home',
  components: { ChinaMap, saleline, salecircle },
  data () {
    return {
      messageCount: '--',
      total: '--',
      onlineTotal: '--',
      provinceChartData: [], // 地图的省份图表数据
      cityChartData: [], // 地图的城市图表数据,
      lineCharData: [],
      pieCharData: []
    }
  },
  created () {
    this.getDeviceCount()
    this.getHomeMap()
  },
  mounted () {
    var liHeight = document.getElementsByClassName('device_statu')[0].offsetHeight
    setTimeout(() => {
      startmarquee(liHeight, 50, 500, 'messageContent')
    }, 500)
    // this.$nextTick(() => {
    //   startmarquee(liHeight, 50, 500, 'messageContent')
    // })
  },
  methods: {
    getDeviceCount () {
      const params = {}
      deviceCount(params).then(res => {
        res = res.data
        this.onlineTotal = res.data.onlineTotal
        this.total = res.data.total
        this.messageCount = res.data.msgTotal
        // console.log('返回的设备数据：', res)
      })
    },
    getHomeMap () {
      homeMap().then(res => {
        res = res.data
        // console.log(res)
        // 折线图处理
        const lineArr = []
        Object.keys(res.data.allProvince).forEach((key) => {
          const obj = { name: key, value: res.data.allProvince[key] }
          lineArr.push(obj)
        })
        this.lineCharData = lineArr.sort(function (a, b) {
          return b.value - a.value
        }).slice(0, 5)
        Object.keys(res.data.onLineProvince).forEach((key) => {
          const obj = { name: key, value: res.data.onLineProvince[key] }
          this.pieCharData.push(obj)
        })
        const allProvince = res.data.allProvince
        const allTopCity = res.data.allTopCity
        // 组装成地图需要的数据
        const provinceChartData = []
        const cityChartData = []
        Object.keys(allProvince).forEach(key => {
          let name = key
          name = name.indexOf('内蒙古') >= 0 ? '内蒙古' : name
          name = name.indexOf('新疆') >= 0 ? '新疆' : name
          name = name.indexOf('广西') >= 0 ? '广西' : name
          name = name.indexOf('宁夏') >= 0 ? '宁夏' : name
          name = name.indexOf('西藏') >= 0 ? '西藏' : name
          name = name.replace(/省/, '')
          name = name.replace(/市/, '')
          name = name.replace(/特别行政区/, '')
          const item = { name: name, value: allProvince[key] }
          provinceChartData.push(item)
        })
        Object.keys(allTopCity).forEach(key => {
          const item = { name: key.split('-')[1], value: allTopCity[key] }
          cityChartData.push(item)
        })
        // console.log('z组装后的provinceChartData：', provinceChartData)
        // console.log('z组装后的cityChartData：', JSON.stringify(cityChartData))
        this.cityChartData = cityChartData
        this.provinceChartData = provinceChartData
      })
    }

  }
}
</script>

<style lang="less" scoped>
 .container{
   display: flex;
   height: calc(100%- 60px);
   flex-direction: row;
   padding: 0 15px;
   position: relative;
 }
  .left {
    text-align: center;
    width: 20%;
    /*background-color: lightslategray;*/
    .top{
      padding-top: 10px;
      width: 100%;
      margin: 30px 0;
      height: 300px;
      border: 1px solid lightgray;
      border-radius: 30px;
    }
    .bottom{
      padding-top: 10px;
      width: 100%;
      margin: 30px 0;
      height: 450px;
      border: 1px solid lightgray;
      border-radius: 30px;
    }
  }

  .middle {
    width: 60%;
    .info_menus{
      text-align: center;
      margin-top: 30px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      .item{
        line-height: 30px;
        // width: 80px;
        .border{
           border-top: 1px solid #00b9ed;
           margin-left: 30%;
           margin-right: 30%;
        }
        .count{
          color: #00b9ed;
          font-size: 30px;
        }
      }
    }
    /*background-color: #7a9926;*/

  }
  .rightContent{
    position: absolute;
    right: 0;
    width: 20%;
    height: 100%;
    .right {
      width: 90%;
      height: 100%;
      padding-top: 20px;
       padding-bottom: 20px;
      text-align: center;
      /*background-color: #5a9955;*/
      border: 1px solid lightgray;
      border-radius: 30px;
      margin: 30px 0;
      display: flex;
      flex-direction: column;
      .messageContent{
        flex: auto;
        overflow: hidden;
      }
      .device_statu{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        height: 50px;
        border: 1px solid lightgray;
        margin: 20px 10px;
      }
      .title_menus{
        padding: 20px 0;
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        .message{
          display: block;
        }
      }
    }
  }

</style>
